import React from 'react'
import { FaRegCircleUser } from 'react-icons/fa6'
import { GoHomeFill } from 'react-icons/go'
import { IoIosLogOut, IoIosSettings } from 'react-icons/io'
import { Link } from "react-router-dom"
import styles from './Index.module.css';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ErrorMessage from '../../common/errorMsg'
import httpService from '../../../services/http.service'
import WarningMessage from '../../common/warnMsg'
import SuccessMessage from '../../common/successMsg'
const NavBar = () => {
    const accountNo = localStorage.getItem("customerId")

    const history = useHistory()

    const handleLogout = async () => {
        try {

            const dataObj = {
                userId: localStorage.getItem("UserId")
            }
            const { data } = await httpService.CreateUpdate("logout", dataObj)

            if (data.ack === 0) {
                return WarningMessage(data.msg)
            }

            if (data.ack === 1) {
                SuccessMessage(data.msg)
            }

            localStorage.clear()

            history.push("/")

        } catch (error) {
            ErrorMessage("Something went wrong")
        }
    }

    return (
        <div className={styles.navBar}>
            <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
                <div className={styles.btn} style={{ borderRadius: 10, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }} onClick={() =>history.push("/property-manager-dashboard")}>
                    <GoHomeFill size={25} />
                </div>
                <p style={{ fontSize: 17 }}>Radiant Stream Director Property Manager Portal</p>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div className={styles.btn} onClick={() => history.push("/property-manager-dashboard/settings/users")}>
                    <IoIosSettings size={25} />
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <FaRegCircleUser size={25} />
                    <p style={{ fontSize: 17 }}>{accountNo}</p>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 6, color: "white", backgroundColor: "red", cursor: "pointer", padding: 8, borderRadius: 5 }} onClick={() => handleLogout()}>
                    <IoIosLogOut size={25} />
                    <p style={{ fontSize: 15 }}>Logout</p>
                </div>
            </div>
        </div>
    )
}

export default NavBar